import { EnergyBalanceTableComponent } from '@/components/energy-balance-table/energy-balance-table';
import { Component, type OnInit, inject } from '@angular/core';
import type { BalanceTableSettings, BalanceTableTranslationKeys } from '../../../interfaces/Widget.interface';
import { WidgetProvider } from '../../../providers/widget.provider';
import { WidgetSize } from '../../../providers/widgets.contants';
import { BudgetBalanceTableComponent } from '../../budget-balance-table/budget-balance-table';
import { AbstractWidgetClass } from '../AbstractWidget.class';

@Component({
    styleUrls: ['./widget-balance-table.scss'],
    selector: 'widget-balance-table',
    templateUrl: 'widget-balance-table.html',
    imports: [BudgetBalanceTableComponent, EnergyBalanceTableComponent]
})
export class WidgetBalanceTableComponent extends AbstractWidgetClass<BalanceTableTranslationKeys, BalanceTableSettings> implements OnInit {
    private _widgetsProvider = inject(WidgetProvider);

    size = WidgetSize.FULL;

    isCostIndicatorCode!: boolean;

    ngOnInit() {
        this.isCostIndicatorCode = this._widgetsProvider.isIndicatorCodeCost(this.config.timeseriesIndicator);
    }
}
